import Vue from "vue";
import Vuex from "vuex";
import axios from 'axios'

import AuthControl from './modules/AuthControl'
import SelectControl from './modules/SelectControl'
import UsersControl from './modules/UsersControl'

import AdminsControl from './modules/AdminsControl'
import DistributorsControl from './modules/DistributorsControl'
import AgentsControl from './modules/AgentsControl'
import MusicControl from './modules/MusicControl'
import ThemesControl from './modules/ThemesControl'
import PartnerControl from './modules/PartnerControl'
import ChallengeControl from './modules/ChallengeControl'
import EventsControl from './modules/EventsControl'
import DashboardControl from './modules/DashboardControl'
import WaitinglistControl from './modules/WaitinglistControl'
import WebsiteControl from './modules/WebsiteControl'
import BonusControl from './modules/BonusControl'

Vue.use(Vuex);

const token = localStorage.getItem('token')
axios.interceptors.request.use(
  (config) => {
    config.headers['Authorization'] = `Bearer ${ token }`;
    return config;
  },

  (error) => {
    return Promise.reject(error);
  }
);


export default new Vuex.Store({
  state:{
    isLoading:false,
  },
  modules: {
    AuthControl,
    SelectControl,
    UsersControl,
    AdminsControl,
    DistributorsControl,
    AgentsControl,
    MusicControl,
    ThemesControl,
    PartnerControl,
    ChallengeControl,
    EventsControl,
    WaitinglistControl,
    DashboardControl,
    WebsiteControl,
    BonusControl
  }
});
